/* This file is autogenerated, see readme.md for instructions */
import ChevronUpSvgIcon from '@bloomreach/banana-theme/icons/chevron-up.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronUpIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronUpSvgIcon />
    </Icon>
  );
});

ChevronUpIcon.displayName = 'ChevronUpIcon';

export default ChevronUpIcon;
